import Chart from "chart.js/auto";
import "chartjs-adapter-dayjs";
import dayjs from "dayjs";
import React, { useEffect, useRef } from "react";
import { injectIntl, IntlShape } from "react-intl";
import { ChartHelpers } from "./chartHelpers";

type Props = {
  currencyCode: string;
  selectedOddsType: string;
  runnerData: Array<Record<string, any>>;
  liquidityOfBestRunner: Array<number>;
  intl: IntlShape;
};

const LandingPageChart: React.FC<Props> = (props: Props) => {
  const chartRef = useRef<HTMLCanvasElement>(null);
  const [chart, setChart] = React.useState<Chart | null>(null);

  useEffect(() => {
    createGraph();
    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  }, [props.selectedOddsType]);

  const createGraph = () => {
    if (chart && chart !== null) {
      chart.destroy();
    }

    const ctx = chartRef.current && chartRef.current.getContext("2d");
    if (!ctx) {
      return null;
    }
    const makeChart = new Chart(ctx, {
      type: "bar",
      // For multi chart graphs, set the type for each dataset as well
      data: {
        // All chart data should have the same snapshot date, so use first runner to generate the horizontal axis labels
        labels: props.runnerData[0].pricePoints.map((pricePoint, index) => {
          return dayjs(pricePoint.snapshotDate);
        }),
        datasets: ChartHelpers.getDatasets(props),
      },
      options: getOptions(),
    });
    makeChart.props = props;
    setChart(makeChart);
  };

  const getOptions = () => {
    return {
      title: {
        display: false,
      },
      maintainAspectRatio: false,
      scales: ChartHelpers.getScales(props),
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
          callbacks: {
            title: ChartHelpers.getToolTipTitle,
            label: ChartHelpers.getTooltipText,
            labelTextColor: ChartHelpers.getLabelTextColor,
            labelColor: ChartHelpers.getLabelColor,
          },
        },
      },
    };
  };

  return (
    <div className="chartjs-container">
      <canvas className="landing-page-graph" ref={chartRef} />
    </div>
  );
};

export default injectIntl(LandingPageChart);
